import { Heart, ShoppingBag } from "lucide-react";
import { motion } from "motion/react";
import { useWishlist } from "@/theme1/hooks/useWishlist";
import { useCart } from "@/theme1/hooks/useCart";

export function ProductActions({ product }) {
  const { isWishlisted, toggleWishlist } = useWishlist();
  const { add } = useCart();

  const wished = isWishlisted(product.slug);

  const handleWishlist = (event) => {
    event.preventDefault();
    event.stopPropagation();
    toggleWishlist(product);
  };

  const handleQuickAdd = (event) => {
    event.preventDefault();
    event.stopPropagation();

    add(product, {
      quantity: 1,
    });
  };

  return (
    <>
      <motion.button
        type="button"
        whileTap={{ scale: 0.92 }}
        onClick={handleWishlist}
        aria-label={wished ? "Remove from wishlist" : `Add ${product.title} to wishlist`}
        className="absolute right-4 top-4 z-20 flex size-11 items-center justify-center rounded-full bg-white/80 text-neutral-950 shadow-sm backdrop-blur-xl transition hover:bg-white focus:outline-none focus:ring-2 focus:ring-neutral-950 focus:ring-offset-2"
      >
        <Heart
          size={18}
          className={wished ? "fill-red-600 text-red-600" : ""}
        />
      </motion.button>

      <motion.button
        type="button"
        whileTap={{ scale: 0.98 }}
        onClick={handleQuickAdd}
        disabled={product.isSoldOut}
        aria-label={
          product.isSoldOut
            ? `${product.title} is sold out`
            : `Quick add ${product.title}`
        }
        className="absolute cursor-pointer inset-x-4 bottom-4 z-20 flex translate-y-3 items-center justify-center gap-2 rounded-full bg-white px-5 py-3 text-sm font-semibold text-neutral-950 opacity-0 shadow-xl transition duration-300 hover:bg-neutral-100 focus:outline-none focus:ring-2 focus:ring-neutral-950 focus:ring-offset-2 group-hover:translate-y-0 group-hover:opacity-100 disabled:cursor-not-allowed disabled:bg-neutral-200 disabled:text-neutral-500"
      >
        <ShoppingBag size={17} />
        {product.isSoldOut ? "Sold Out" : "Quick Add"}
      </motion.button>
    </>
  );
}